import dynamic from "next/dynamic";

const ReactApexChart = dynamic(
  () => import("react-apexcharts"),
  { ssr: false }
);

export function TreeMap({dataMap}) {
  let parseData = dataMap.map((item) => ({
    x: item.papel + "\n" + item.variacao,
    y: parseFloat(item.variacao.replace('%','').replace(',','.')),
  }))
  parseData.sort((itemA, itemB) => itemB.y - itemA.y);
  const state = {
    series: [{ data: parseData }],
    options: {
      chart: {
        height: 640,
        type: "treemap",
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: "12px",
        }
      },
      plotOptions: {
        treemap: {
          enableShades: true,
          shadeIntensity: 0.5,
          reverseNegativeShade: true,
          colorScale: {
            ranges: [
              {
                from: -9999,
                to: -3,
                color: "#ff0000",
              },
              {
                from: -2.999,
                to: -2,
                color: "#be3e4c",
              },
              {
                from: -1.999,
                to: -1,
                color: "#864652",
              },
              {
                from: -0.999,
                to: -0.2,
                color: "#574952",
              },
              {
                from: -0.199,
                to: 0.199,
                color: "#444557",
              },
              {
                from: 0.2,
                to: 0.999,
                color: "#495753",
              },
              {
                from: 1,
                to: 1.999,
                color: "#377751",
              },
              {
                from: 2,
                to: 2.999,
                color: "#3c9a5b",
              },
              {
                from: 3,
                to: 9999,
                color: "#38cb61",
              },
            ],
          },
        },
      },
    },
  };

  return (
    <div id="chart">
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="treemap"
        height={640}
      />
    </div>
  );
}
